import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import Loader from "@/components/loader";
import { ApacConfigurationsProvider } from "@/utils/contentfulTranslations";
import "@/styles/globals.scss";
const Layout = dynamic(() => import("@/components/Layout"));
const ErrorBoundary = dynamic(() => import("@/components/errorBoundary"));

const MyApp = ({ Component, pageProps }) => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const start = () => setLoading(true);
    const end = () => setLoading(false);

    router.events.on("routeChangeStart", start);
    router.events.on("routeChangeComplete", end);
    router.events.on("routeChangeError", end);

    return () => {
      router.events.off("routeChangeStart", start);
      router.events.off("routeChangeComplete", end);
      router.events.off("routeChangeError", end);
    };
  }, [router.events]);

  const {
    headerNavigationData,
    footerNavigationData,
    world = {},
    promoBannerData = {},
    apacConfigurationsData = {},
    translations,
  } = pageProps;

  return (
    <ErrorBoundary>
      <ApacConfigurationsProvider
        apacConfigurationsData={translations}
        formConfigurationsData={apacConfigurationsData}
      >
        <Layout
          headerNavigationData={headerNavigationData}
          footerNavigationData={footerNavigationData}
          seoMetadata={pageProps?.pageData?.seoMetadata}
          world={world}
          promoBannerData={promoBannerData}
        >
          <Component {...pageProps} />
        </Layout>
      </ApacConfigurationsProvider>
      {loading && <Loader loading={loading} />}
    </ErrorBoundary>
  );
};

MyApp.propTypes = {
  Component: PropTypes.elementType.isRequired,
  pageProps: PropTypes.object.isRequired,
};

export default MyApp;
